import { Outlet, createFileRoute } from '@tanstack/react-router';
import { PortalFrame } from '@/features/creator-portal/portal-frame';

/**
 * A creator's portal: public, no sign-in and no team. The token in the path is the only key (the pages send it to the
 * API in a header, never in the API's path). Every page under it shares the frame (the studio field and Dreamwell's
 * wing); the frame and the pages are split out of the entry, so the sign-in page's budget never pays for them.
 */
export const Route = createFileRoute('/creator/$token')({
  component: CreatorPortalLayout,
});

function CreatorPortalLayout() {
  return (
    <PortalFrame>
      <Outlet />
    </PortalFrame>
  );
}
